import { Component, OnInit, OnDestroy } from "@angular/core";
import { Contract } from "@edp-components/edp-contract";
import { PaymentReferenceData } from "@edp-models/edp-payment-reference.model";
import { select, Store } from "@ngrx/store";
import { takeUntil } from "rxjs/operators";
import { IAppState } from "@edp-store/state/app.state";
import { Subject } from "rxjs";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { getBalance, getInvoices } from "@edp-store/selectors/dashboard.selectors";
import { IInvoice, IInvoicesChart } from "@edp-models/invoices.model";

@Component({
    selector: "edp-widget-without-billing",
    templateUrl: "./edp-widget-without-billing.component.html"
})
export class EdpWidgetWithoutBillingComponent implements OnInit, OnDestroy {
    public contract: Contract;
    public totalInvoices: number;
    public paymentData: PaymentReferenceData;
    public balanceObject: {
        movements?: any;
        dateFrom?: string;
        dateTo?: string;
        balance?: number;
        debtBalance?: number;
        invoices?: IInvoice[];
        invoicesChart?: IInvoicesChart[];
    };
    public dateLimit: any;
    public invoices = [];
    public showChart: boolean;

    protected unsubscribe = new Subject();

    constructor(
        public store: Store<IAppState>
    ) { }

    public ngOnInit() {
        this.store.pipe(
            takeUntil(this.unsubscribe),
            select(getContract)
        ).subscribe(contract => {
            this.contract = contract;
        });

        this.store.pipe(
            takeUntil(this.unsubscribe),
            select(getBalance)
        ).subscribe(balance => {
            this.balanceObject = balance;
            this.calculateData();
        });

        this.store.pipe(
            takeUntil(this.unsubscribe),
            select(getInvoices)
        ).subscribe(invoicesData => {
            this.invoices = invoicesData && invoicesData.invoices && invoicesData.invoices.length > 0
                ? invoicesData.invoices : [];
            this.calculateData();
        });
    }

    public ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    private calculateData() {
        if (this.invoices.length > 0) {
            this.dateLimit = this.invoices[0].faedn;
            this.paymentData = {
                PaymentReference: this.invoices[0].paymentReference,
                PaymentEntity: this.invoices[0].paymentEntity,
                PaymentValue: this.invoices[0].paymentValue
            };
            this.totalInvoices = this.invoices.filter((invoice) => {
                return (invoice.status === "NP");
            }).length;
        } else if (this.balanceObject.movements && this.balanceObject.movements.length !== 0) {
            this.dateLimit = this.balanceObject.movements[0].DueDate;
        } else {
            this.dateLimit = null;
        }
    }

}
